.icon {
  height: 18px;
  width: 18px;
  background: white;
  opacity: 1;
  border-radius: 50%;
}
